<template>
  <v-card tile class="mt-6">
    <v-card-title class="font-weight-regular justify-space-between">
      <span>
        {{ $t('USERS.ACCESS_TO_THE_APP') }}
        <v-icon
          v-if="!editMode"
          class="ml-2"
          color="indigo"
          @click="toggleEditMode"
          >{{
            isUser ? 'mdi-square-edit-outline' : 'mdi-plus-box-outline'
          }}</v-icon
        >
        </span>
      <welcome-letter
        v-if="form.user"
        :user="form.user"
        :firstName="value.first_name"
        :lastName="value.last_name"
        :personId="value.id"
      />
    </v-card-title>
    <v-divider></v-divider>

    <v-card-text>
      <v-form v-model="valid" class="px-4">
        <v-row>
          <v-col>
            <user-information-form
              v-model="form.user"
              :readonly="!editMode"
              :errors="errors.getAll()"
              @update-prop="clearErrorByName($event)"
            ></user-information-form>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-0">
            <div v-if="editMode">
              <v-btn
                outlined
                class="mr-5"
                depressed
                color="grey"
                large
                @click="cancel"
              >
                {{ $t('BUTTON.CANCEL') }}
              </v-btn>
              <v-btn
                v-if="isUser"
                depressed
                type="submit"
                :disabled="!valid"
                large
                color="primary"
                class="mr-5"
                @click.prevent="updateUser"
              >
                {{ $t('BUTTON.UPDATE') }}
              </v-btn>
              <v-btn
                v-else
                depressed
                type="submit"
                :disabled="!valid"
                large
                color="primary"
                class="mr-5"
                @click.prevent="createUser"
              >
                {{ $t('BUTTON.CREATE') }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import errors from '@/modules/_global/mixins/errors';
import { cloneDeep, isEqual } from 'lodash';
import UserInformationForm from '@/modules/persons/components/forms/UserInformationForm';
import WelcomeLetter from '@/modules/persons/components/WelcomeLetter/WelcomeLetter.vue';
import { mapActions } from 'vuex';

export default {
  name: 'UserInformation',

  components: { UserInformationForm, WelcomeLetter },

  mixins: [errors],

  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },

  data: () => ({
    form: {},
    valid: false,
    editMode: false,
    formCopy: null
  }),

  computed: {
    isUser() {
      return !!(
        this.form.user &&
        Object.keys(this.form.user).length &&
        this.form.user.id
      );
    }
  },

  watch: {
    editMode: {
      deep: true,
      immediate: true,
      handler: function(v) {
        if (v) {
          this.formCopy = cloneDeep(this.form);
        }
      }
    },

    value: {
      deep: true,
      immediate: true,
      handler: function(formProps) {
        if (isEqual(formProps, this.form)) {
          return;
        }

        this.form = {
          ...this.form,
          ...formProps
        };

        this.emitter();
      }
    }
  },
  methods: {
    ...mapActions('user', ['store', 'update']),

    emitter() {
      this.$emit('input', this.form);
    },

    toggleEditMode() {
      this.editMode = !this.editMode;
    },

    cancel() {
      this.form = cloneDeep(this.formCopy);
      this.toggleEditMode();
    },

    createUser() {
      this.store({
        person_id: this.value.id,
        ...this.form.user
      })
        .then(response => {
          this.$emit('update');
          this.toggleEditMode();
        })
        .catch(({ response }) => {
          this.handleErrorsByResponse(response);
        });
    },

    updateUser() {
      this.update(this.form.user)
        .then(response => {
          this.$emit('update');
          this.toggleEditMode();
        })
        .catch(({ response }) => {
          this.handleErrorsByResponse(response);
        });
    }
  }
};
</script>

<style scoped></style>
